import { C } from '../theme/palette';

export const MODELES = [
  {
    id: 'simple',
    icon: '📋',
    nom: 'Devis simple',
    col: '#1E3A5F',
    lignes: [
      { d: 'Prestation', u: 'forfait', q: 1, p: 500 },
      { d: 'Fourniture / matériel', u: 'forfait', q: 1, p: 200 },
    ],
  },
  {
    id: 'detaille',
    icon: '📑',
    nom: 'Devis détaillé',
    col: '#0E7490',
    lignes: [
      { d: "Main-d'œuvre", u: 'h', q: 10, p: 90 },
      { d: 'Matériel / fournitures', u: 'forfait', q: 1, p: 400 },
      { d: 'Frais de déplacement', u: 'forfait', q: 1, p: 80 },
    ],
  },
  {
    id: 'regie',
    icon: '⏱️',
    nom: 'Régie (taux horaire)',
    col: '#6D28D9',
    lignes: [
      { d: 'Heures de travail', u: 'h', q: 8, p: 95 },
      { d: 'Déplacement (aller-retour)', u: 'forfait', q: 1, p: 60 },
    ],
  },
  {
    id: 'forfait',
    icon: '📦',
    nom: 'Forfait global',
    col: '#0F6B3A',
    lignes: [{ d: 'Prestation forfaitaire (tout compris)', u: 'forfait', q: 1, p: 1500 }],
  },
  {
    id: 'service',
    icon: '🛠️',
    nom: 'Prestation de service',
    col: '#B45309',
    lignes: [
      { d: 'Service / conseil', u: 'h', q: 5, p: 120 },
      { d: 'Frais annexes', u: 'forfait', q: 1, p: 100 },
    ],
  },
  { id: 'vierge', icon: '➕', nom: 'Modèle vierge', col: '#1E3A5F', lignes: [] },
];

export const DEVIS_STYLES = [
  { id: 'suisse', nom: 'Classique', accent: '#1F2A37', lay: 'suisse' },
  { id: 'edserif', nom: 'Serif', accent: '#1F2A37', lay: 'edserif' },
  { id: 'titreDroite', nom: 'Titre à droite', accent: '#1F2A37', lay: 'titreDroite' },
  { id: 'logoCentre', nom: 'Logo centré', accent: '#1F2A37', lay: 'logoCentre' },
  { id: 'bandeauFin', nom: 'Bandeau fin', accent: '#1F2A37', lay: 'bandeauFin' },
  { id: 'encadreTitre', nom: 'Titre encadré', accent: '#1F2A37', lay: 'encadreTitre' },
  { id: 'titreGauche', nom: 'Titre à gauche', accent: '#1F2A37', lay: 'titreGauche' },
  { id: 'doubleFilet', nom: 'Double filet', accent: '#1F2A37', lay: 'doubleFilet' },
];

export const HL_MAP = {
  // Libellés affichés en capitales par la feuille, traduits dans la langue du document.
  urgent: { c: '#C43736', bg: '#FCEBEB', lab: 'Urgent' },
  option: { c: '#B45309', bg: '#FFF6E6', lab: 'Option' },
  valide: { c: '#0F6B3A', bg: '#E9F6EE', lab: 'Validé' },
  info: { c: '#1D4ED8', bg: '#EEF2FF', lab: 'Info' },
};

export const FSTATUTS = {
  Brouillon: C.muted,
  Envoyée: C.teal,
  Payée: C.green,
  Partielle: C.amber,
  Annulée: C.red,
  Rectifiée: C.purple,
};

export const CMD_STATUTS = {
  Reçue: C.red,
  'À préparer': C.amber,
  Prête: C.teal,
  Livrée: C.green,
  Facturée: C.purple,
};
